import { Injectable } from '@angular/core';

// add my services and common stuff here
import * as Constants from 'src/app/services/constants/constants';


/*
  NOTE:  There are THREE MAIN CATEGORIES OF PUSH NOTIFICATIONS:
  (1) Survey Notification (with ability to answer survey)
  (2) Actionable Notification (with ability to execute action)
  (3) Ambit Message (various sub-categories, see below)
    - Ambit Message: Assignment (Support, Report, Door Access)
    - Ambit Message: Notification (Support, Report, Door Access, Reference updates, etc.)
    - Ambit Message: Simple message (from System Client "SendAmbitMessage" button)
    - Ambit Message: Test Push (from Mobile App "Test Push" button)

  THIS CLASS DEALS WITH (3) ABOVE:  Ambit Message
*/

@Injectable()
export class AmbitMessagePush 
{
  consoleLog:boolean = true;

  MessageTitle:string = "";
  MessageSubTitle:string = "";
  MessageText:string = "";
  MessageLevelCode:string = "";
  MessageInfo:string = "";
  
  //new 
  MobileMediaCount: string = "";
  MobileMediaListMobileMediaId: string = "";

  constructor(notificationPayload:any) 
  { 
    if (this.consoleLog) console.log('AmbitMessagePush.ctor - LifeCycle', notificationPayload); 

    if (!notificationPayload) { return; }

    // NOTE: Set the Title based on the Ambit Messag type 
    //       - currently both Event Notifications and Ambit Messages are using the same message protocol...
    this.MessageTitle = Constants.MESSAGE_TITLE_AMBITMESSAGE;  // notificationPayload.AmbitMessageFlag === "True"
    this.MessageSubTitle = notificationPayload.StructuredFormMessageLevelCode || "";
    this.MessageText = notificationPayload.StructuredFormMessageText || "";
    this.MessageLevelCode = notificationPayload.StructuredFormName || "";
    this.MessageInfo = notificationPayload.StructuredFormMessageText || "";
    this.MobileMediaCount = notificationPayload.MobileMediaCount || "";
    this.MobileMediaListMobileMediaId = notificationPayload.MobileMediaListMobileMediaId || "";
  }
}
